import {
  OrderAttributes,
  OrderDetailAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { OrderStatusERPEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/order-status-erp.enum";
import { CommonModule, DecimalPipe } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit, OnDestroy } from "@angular/core";

// SmartGrid Imports
import {
  SmartGridComponent,
  ColDef,
  GridConfig,
  PageChangedEvent,
  SortChangedEvent,
  GridReadyEvent,
} from 'app/shared/components/smart-grid';
import { RouteUserCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/route-user-cell-renderer/route-user-cell-renderer.component';
import { TripNavigationCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/trip-navigation-cell-renderer/trip-navigation-cell-renderer.component';
import { DateHourCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/date-hour-cell-renderer/date-hour-cell-renderer.component';
import { CustomerCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/customer-cell-renderer/customer-cell-renderer.component';
import { MaterialCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/material-cell-renderer/material-cell-renderer.component';
import { QuantityCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/quantity-cell-renderer/quantity-cell-renderer.component';
import { CurrencyCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/currency-cell-renderer/currency-cell-renderer.component';
import { ActionsCellRendererComponent } from 'app/shared/components/smart-grid/cell-renderers/actions-cell-renderer/actions-cell-renderer.component';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import {
  MatSidenavContainer,
  MatSidenavModule,
} from "@angular/material/sidenav";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FilterSectionComponent } from "app/common/components/filter-section/filter-section.component";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { DocumentTypeEnum } from "app/common/enums/document-types.enum";
import { IPaginationResult } from "app/common/interfaces";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { CompanyService } from "app/modules/components/configuration/company/company.service.service";
import { WarehouseService } from "app/modules/components/configuration/warehouse/warehouse.service";
import { BusinessPartnersFiltersComponent } from "app/modules/components/filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "app/modules/components/filters/configuration-filters/configuration-filters.component";
import { DatesFiltersComponent } from "app/modules/components/filters/dates-filters/dates-filters.component";
import { DocumentsFiltersComponent } from "app/modules/components/filters/documents-filters/documents-filters.component";
import { IFilters } from "app/modules/components/filters/interfaces/filterInterface";
import { MaterialsManagementFiltersComponent } from "app/modules/components/filters/materials-management-filters/materials-management-filters.component";
import { RoutesFiltersComponent } from "app/modules/components/filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "app/modules/components/filters/status-filters/status-filters.component";
import { MaterialService } from "app/modules/components/material/material/material.service";
import { SubRouteService } from "app/modules/components/routing/sub-routes/sub-route.service";
import { OrdersListService } from "app/modules/components/sales/order-list-components/order-list.service";
import { DocumentFlowButtonComponent } from "app/modules/shared/document-flow-button/document-flow-button.component";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";
import { DecimalConfigService } from "app/services/decimal-config.service";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { FormatOtherDateHourPipe } from "app/pipes/other-date.pipe";
import { DecimalFormatPipe } from "app/pipes/decimal-company.pipe";
import { UserRouteDisplayComponent } from "app/shared/components/user-route-display/user-route-display.component";
import { OrderCustomerExport } from "../order-customer/exports/order-customer.export";
import { getCode } from "app/utils/method";
import { debounceTime, distinctUntilChanged, Subscription } from "rxjs";
import { DateHelper } from "app/utils/date.helper";
import { ExportDialogComponent } from "app/layout/export-overlay";
import { ORDER_LOSS_EXPORT_ID, ORDER_LOSS_TITLE } from "../order-customer/exports/order-customer.constants";
import { OrderCustomerService } from "../order-customer/order-customer.service";


@Component({
  selector: "app-loss-list",
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatButtonModule,
    MatIconModule,
    SmartGridComponent,  // Added for SmartGrid migration
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSidenavModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatDialogModule,
    NgxMatSelectSearchModule,
    FormatOtherDateHourPipe,
    MatAutocompleteModule,
    FilterComponent,
    DecimalFormatPipe,
    DocumentFlowButtonComponent,
    MatMenuModule,
    FilterSectionComponent,
    StatusFiltersComponent,
    MaterialsManagementFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    DocumentsFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    UserRouteDisplayComponent,
    HoverMenuDirective,
    CompanyCurrencyPipe,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    OrderCustomerExport,
    DecimalPipe,
  ],
  templateUrl: "./loss-list.component.html",
})
export class LossListHComponent implements OnInit, OnDestroy {
  getCode = getCode;
  private decimalPipe = new DecimalPipe('en-US');
  OrderStatusERPEnum = OrderStatusERPEnum;
  type = DocumentTypeEnum.DOCUMENTO_MERMA;
  displayedColumns: string[] = [
    "routeUser",
    "trip",
    "serials",
    "date",
    "shipToExternalKeyCode",
    "soldTo",
    "materialName",
    "soldQuantity",
    "unitPrice",
    "subTotal",
    "total",
    "actions",
  ];

  dataSource = new MatTableDataSource<OrderDetailAttributes>([]);

  // SmartGrid properties
  data: any[] = [];
  loading: boolean = false;
  columnDefs: ColDef<any>[] = [];
  gridConfig: GridConfig<any> = {
    rowIdField: '_id' as any,
    dataMode: 'api',
    sorting: {
      enabled: true,
      mode: 'api',
      multiColumn: false,
      defaultSort: [
        { field: '_id', direction: 'desc' }
      ],
    },
    pagination: {
      enabled: true,
      mode: 'api',
      pageSize: 50,
      pageSizeOptions: [50, 100, 150, 200],
      showPaginator: true,
      showFirstLastButtons: true,
    },
    search: {
      enabled: true,
      mode: 'api',
      showSearchInput: false,
    },
    columnFilters: {
      enabled: true,
      mode: 'local',
    },
    selection: {
      enabled: false,
    },
  };

  //#region FILTER
  totalItems: number = 0;
  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderDetailAttributes = "_id";
  sortDirection: "ASC" | "DESC" = "DESC";

  filter = {
    company: null,
    dateini: new Date(),
    dateend: new Date(),
    warehouseId: null,
    routes: [],
    item: null,
  };

  ordersToFilter: string[] = [];

  range = new FormGroup({
    start: new FormControl<Date | null>(new Date()),
    end: new FormControl<Date | null>(new Date()),
  });
  //#endregion

  UMPActive: boolean;

  //#region Subsription
  subs: Subscription[] = [];
  searchSubscription: Subscription;
  //#endregion

  form: FormGroup;

  //Para filtros
  selectedStatuses: number[] = [];

  // Estados ERP
  selectedERPStatuses: number[] = [];

  selectedCustomerType: string[] = [];

  loadConfigData = false;
  loadDocumentsData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadMaterialsData = false;

  constructor(
    private orderCustomer: OrderCustomerService,
    private readonly warehouseService: WarehouseService,
    private readonly subRouteService: SubRouteService,
    private readonly companyService: CompanyService,
    private ordersListService: OrdersListService,
    private snackBar: MatSnackBar,
    private matDialog: MatDialog,
    private readonly cdr: ChangeDetectorRef,
    private orderCustomerExport: OrderCustomerExport,
    private readonly materialService: MaterialService,
    private readonly searchService: SearchService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private companyCurrencyPipe: CompanyCurrencyPipe,
    private decimalConfigService: DecimalConfigService,
    private fb: FormBuilder
  ) {
    const today = new Date();
    this.form = this.fb.group({
      start: [today],
      end: [today],
      startTrip: [],
      endTrip: [],
      companyId: [],
      salesOfficeId: [],
      documentClassId: [],
      subRouteId: [],
      assignedUserId: [],
      payingBusinessPartnerId: [],
      receivingBusinessPartnerId: [],
      warehouseId: [],
      end_startTrip: [],
      end_endTrip: [],
      soldToControl: [],
      searchReceivingBusinessPartner: [],
      searchAssignedUser: [],
      materialGroupId: [[]],
      materialId: [],
    });
  }

  private formatCurrency(value: number): string {
    if (value == null) return '-';
    const decimals = this.decimalConfigService.getDecimals();
    const formattedNum = this.decimalPipe.transform(value, `1.${decimals}-${decimals}`) ?? '-';
    if (formattedNum === '-') return '-';
    const symbol = this.companyCurrencyPipe.transform('symbol');
    return `${symbol} ${formattedNum}`;
  }

  private createCurrencyFilterOptions(fieldPath: string) {
    return {
      valueExtractor: (item: any) => {
        const value = item[fieldPath];
        return this.formatCurrency(value);
      },
      customFilterFn: (rowData: any, filterValue: string) => {
        const value = rowData[fieldPath];
        const formattedValue = this.formatCurrency(value);
        if (!formattedValue || formattedValue === '-') return !filterValue;
        return formattedValue === filterValue;
      },
    };
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onDocumentsExpanded(): void {
    this.loadDocumentsData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onMaterialsExpanded(): void {
    this.loadMaterialsData = true;
  }

  ngOnInit(): void {
    this.initializeColumnDefs();
    this.fetchCompanies();
    this.subs.push(
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params["code"]) {
          this.ordersToFilter = params["code"] ? params["code"].split(",") : [];
        }
      })
    );
    this.onHandleSearch();
  }

  private initializeColumnDefs(): void {
    this.columnDefs = [
      {
        field: 'subRoute.name' as any,
        headerName: 'Ruta - Usuario',
        minWidth: 300,
        sortable: true,
        pinned: 'left',
        cellRenderer: RouteUserCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => {
            const subRoute = item.subRoute;
            const user = item.user;
            const routeName = subRoute?.name ?? '-';
            const userName = user?.name ?? '-';
            return `${routeName} - ${userName}`;
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const subRoute = rowData.subRoute;
            const user = rowData.user;
            const routeName = subRoute?.name ?? '-';
            const userName = user?.name ?? '-';
            const displayValue = `${routeName} - ${userName}`;
            if (!displayValue || displayValue === '- - -') return !filterValue;
            return displayValue === filterValue;
          },
        },
      },
      {
        field: 'trip.id' as any,
        headerName: 'Viaje',
        minWidth: 140,
        sortable: true,
        cellRenderer: TripNavigationCellRendererComponent,
      },
      {
        field: 'serials',
        headerName: 'Nro. Doc.',
        minWidth: 160,
        sortable: true,
      },
      {
        field: 'date',
        headerName: 'Fecha',
        minWidth: 140,
        sortable: true,
        cellRenderer: DateHourCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => {
            if (!item.date) return '-';
            const date = new Date(item.date);
            return date.toLocaleDateString('es-ES');
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            if (!rowData.date) return !filterValue;
            const date = new Date(rowData.date);
            const formattedDate = date.toLocaleDateString('es-ES');
            return formattedDate === filterValue;
          },
        },
      },
      {
        field: 'shipToExternalKeyCode',
        headerName: 'Receptor',
        minWidth: 200,
        sortable: true,
        cellRenderer: CustomerCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => item.shipToName ?? '-',
          customFilterFn: (rowData: any, filterValue: string) => {
            const shipToName = rowData.shipToName ?? '-';
            if (!shipToName || shipToName === '-') return !filterValue;
            return shipToName === filterValue;
          },
        },
      },
      {
        field: 'soldTo.name' as any,
        headerName: 'Pagador',
        minWidth: 200,
        sortable: true,
        valueFormatter: (value: any, data: any) => {
          const code = data?.soldTo?.externalKeys?.code || data?.soldTo?.code || '';
          const name = data?.soldTo?.name || '';
          return code && name ? `${code} - ${name}` : (code || name || '-');
        },
        filterOptions: {
          valueExtractor: (item: any) => {
            const code = item?.soldTo?.externalKeys?.code || item?.soldTo?.code || '';
            const name = item?.soldTo?.name || '';
            return code && name ? `${code} - ${name}` : (code || name || '-');
          },
          customFilterFn: (rowData: any, filterValue: string) => {
            const code = rowData?.soldTo?.externalKeys?.code || rowData?.soldTo?.code || '';
            const name = rowData?.soldTo?.name || '';
            const displayValue = code && name ? `${code} - ${name}` : (code || name || '-');
            if (!displayValue || displayValue === '-') return !filterValue;
            return displayValue === filterValue;
          },
        },
      },
      {
        field: 'materialName.name' as any,
        headerName: 'Material',
        minWidth: 200,
        sortable: true,
        cellRenderer: MaterialCellRendererComponent,
        filterOptions: {
          valueExtractor: (item: any) => item.materialName?.name ?? '-',
          customFilterFn: (rowData: any, filterValue: string) => {
            const materialName = rowData.materialName?.name ?? '-';
            if (!materialName || materialName === '-') return !filterValue;
            return materialName === filterValue;
          },
        },
      },
      {
        field: 'soldQuantity',
        headerName: 'Cantidad (U.M)',
        minWidth: 180,
        sortable: true,
        cellRenderer: QuantityCellRendererComponent,
        cellRendererParams: {
          getUMPActive: () => this.UMPActive  // Arrow function para valor dinámico
        }
      },
      {
        field: 'unitPrice',
        headerName: 'Precio',
        minWidth: 120,
        sortable: true,
        cellClass: 'text-right',
        cellRenderer: CurrencyCellRendererComponent,
        filterOptions: this.createCurrencyFilterOptions('unitPrice'),
      },
      {
        field: 'subTotal',
        headerName: 'Subtotal',
        minWidth: 120,
        sortable: true,
        cellClass: 'text-right',
        cellRenderer: CurrencyCellRendererComponent,
        filterOptions: this.createCurrencyFilterOptions('subTotal'),
      },
      {
        field: 'total',
        headerName: 'Total',
        minWidth: 120,
        sortable: true,
        cellClass: 'text-right',
        cellRenderer: CurrencyCellRendererComponent,
        filterOptions: this.createCurrencyFilterOptions('total'),
      },
      {
        colId: 'actions',
        headerName: '',
        minWidth: 80,
        maxWidth: 80,
        sortable: false,
        pinned: 'right',
        cellRenderer: ActionsCellRendererComponent,
      },
    ];
  }

  ngAfterViewInit(): void {
    this.onFilter();

    this.searchControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((filterValue: string) => {
        this.pageIndex = 1;
        this.search = filterValue;
        this.onFilter();
      });
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.pageIndex = 1;
        this.search = term;
        this.onFilter();
      }
    );
  }

  onFilter() {
    this.range.valueChanges.subscribe((rangeValues) => {
      this.filter.dateini = rangeValues.start || this.filter.dateini;
      this.filter.dateend = rangeValues.end || this.filter.dateend;
    });

    this.getListReport();
  }

  onClearFilter() {
    this.filter = {
      company: this.filter.company,
      dateini: new Date(),
      dateend: new Date(),
      warehouseId: null,
      routes: [],
      item: null,
    };
    this.range.reset({
      start: new Date(),
      end: new Date(),
    });
    this.form.reset({
      start: new Date(),
      end: new Date(),
    });
    this.onFilter();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1;
    this.search = filterValue;
    this.getListReport();
  }

  changeSort(e) {
    this.sortActive = e.active;
    this.sortDirection = e.direction?.toUpperCase() || "ASC";
    this.getListReport();
  }

  changePage(e) {
    this.pageIndex = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.getListReport();
  }

  // SmartGrid event handlers
  onPageChanged(event: PageChangedEvent): void {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getListReport();
  }

  onSortChanged(event: SortChangedEvent<any>): void {
    if (event.sortStates.length > 0) {
      const sortState = event.sortStates[0];
      this.sortActive = sortState.field as keyof OrderDetailAttributes;
      this.sortDirection = sortState.direction === 'asc' ? 'ASC' : 'DESC';
    } else {
      this.sortActive = '_id';
      this.sortDirection = 'DESC';
    }
    this.getListReport();
  }

  onGridReady(event: GridReadyEvent<any>): void {
    // Grid is ready, can store reference if needed
  }

  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe((res) => {
      if (res.data.length === 1) {
        this.UMPActive = res.data[0].UMPActive;
      }
    });
  }
  private getSortField(): keyof OrderDetailAttributes {
    const sortFieldMapping: Record<string, keyof OrderDetailAttributes> = {
      routeUser: <any>"subRoute.name",
      trip: <any>"trip.id",
      serials: <any>"serials",
      date: <any>"date",
      shipToExternalKeyCode: <any>"shipToExternalKeyCode",
      soldTo: <any>"soldTo.name",
      materialName: <any>"materialName.name",
      soldQuantity: "soldQuantity",
      unitPrice: "unitPrice",
      subTotal: "subTotal",
      total: "total",
    };
    return sortFieldMapping[this.sortActive] || "_id";
  }

  getListReport() {
    this.loading = true;

    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: this.getSortField(),
      sortDirection: this.sortDirection,
    };

    const adjustedStart = new Date(this.filter.dateini);
    adjustedStart.setHours(0, 0, 0, 0); // 00:00:00.000

    const adjustedEnd = new Date(this.filter.dateend);
    adjustedEnd.setHours(23, 59, 59, 999); // 23:59:59.999

    let filter: IFilters = {
      type: this.type,
      startDate: DateHelper.getStartOfDay(this.form.get("start")?.value),
      endDate:
        DateHelper.getEndOfDay(this.form.get("end")?.value) ??
        DateHelper.getEndOfDay(this.form.get("start")?.value) ??
        null,
      startTrip: DateHelper.getStartOfDay(this.form.get("startTrip")?.value),
      endTrip:
        DateHelper.getEndOfDay(this.form.get("endTrip")?.value) ??
        DateHelper.getEndOfDay(this.form.get("startTrip")?.value) ??
        null,
      end_startTrip: DateHelper.getStartOfDay(
        this.form.get("end_startTrip")?.value
      ),
      end_endTrip:
        DateHelper.getEndOfDay(this.form.get("end_endTrip")?.value) ??
        DateHelper.getEndOfDay(this.form.get("end_startTrip")?.value) ??
        null,
      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      warehouseId: this.form.get("warehouseId")?.value, //
      documentClass: this.form.get("documentClassId")?.value,
      subRouteId: this.form.get("subRouteId")?.value, //
      soldTo: this.form.get("payingBusinessPartnerId")?.value,
      shipTo: this.form.get("receivingBusinessPartnerId")?.value,
      seller: this.form.get("assignedUserId")?.value,
      status: this.selectedStatuses ? this.selectedStatuses : null,
      statusERP: this.selectedERPStatuses.length
        ? this.selectedERPStatuses
        : null,
      typeCustomer: this.selectedCustomerType.length
        ? this.selectedCustomerType
        : null,
      materialGroupId: this.form.get("materialGroupId").value,
      materialId: this.form.get("materialId").value,
      ordersToFilter: null,
    };

    if (
      this.ordersToFilter &&
      this.ordersToFilter.length > 0 &&
      (this.search == undefined || this.search == null || this.search == "")
    ) {
      filter.ordersToFilter = this.ordersToFilter;
      filter.start = null;
      filter.end = null;
      filter.startTrip = null;
      filter.endTrip = null;
      filter.end_startTrip = null;
      filter.end_endTrip = null;
    }


    this.orderCustomer
      .findAllWithCount(
        options,
        filter
      )
      .subscribe({
        next: (res: IPaginationResult<OrderDetailAttributes>) => {
          this.dataSource.data = res?.data?.[0]?.data ?? [];
          this.data = res?.data?.[0]?.data ?? [];
          this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.snackBar.open(
            err.error.message || "Error al obtener reporte",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }

  //#region actions
  onExportButtonPressed() {
    if (!this.orderCustomerExport.canStartTask()) return;
    const dialogRef = this.matDialog.open(ExportDialogComponent, {
      data: { title: ORDER_LOSS_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.orderCustomerExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
          ORDER_LOSS_EXPORT_ID,
          ORDER_LOSS_TITLE
        );
      }
    });
  }

  goToTravel(element: OrderAttributes) {
    if (element.trip?.id) {
      const queryParams = { tripId: element.trip.id };
      const urlTree = this.router.createUrlTree(
        ["monitor", "principal-screen"],
        { queryParams }
      );
      const absoluteUrl =
        window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, "_blank");
    }
  }
  //#endregion

  //#region FILTER

  //#endregion

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
